<template>
  <div>
    
    <div class="container">


      <!-- <button @click="changeLocale('pt')">Portuguese</button>
      <button @click="changeLocale('en')">English</button> -->

    <div class="mb-4">
      <h2>{{ t('headings.generalCannabisGrowingCalculators') }}</h2>
      <div class="accordion" id="generalAccordian">
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1" 
          aria-expanded="true" aria-controls="collapse1">
            {{ t('headings.WeightConversion') }}
          </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" data-bs-parent="#generalAccordian">
          <div class="accordion-body">
            
             <weight-conversion></weight-conversion> 

          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
            {{ t('headings.DistanceConversion') }}
          </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" data-bs-parent="#generalAccordian">
          <div class="accordion-body">
            
              <distance-conversion></distance-conversion>
          </div>
        </div>
      </div>


        <!-- Temperature Conversion -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
            {{ t('headings.TemperatureConversion') }}
          </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" data-bs-parent="#generalAccordian">
          <div class="accordion-body">
            <temperature-conversion></temperature-conversion>
          </div>
        </div>
      </div>

      <!-- Speed Conversion -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
            {{ t('headings.SpeedConversion') }}
          </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" data-bs-parent="#generalAccordian">
          <div class="accordion-body">
            <speed-conversion></speed-conversion>
          </div>
        </div>
      </div>

      <!-- Area Conversion -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
            {{ t('headings.AreaConversion') }}
          </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" data-bs-parent="#generalAccordian">
          <div class="accordion-body">
            <area-conversion></area-conversion>
          </div>
        </div>
      </div>

      <!-- Volume Conversion -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
            {{ t('headings.VolumeConversion') }}
          </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" data-bs-parent="#generalAccordian">
          <div class="accordion-body">
            <volume-conversion></volume-conversion>
          </div>
        </div>
      </div>

      <!-- Flow rate Conversion -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
            {{ t('headings.FlowRateConversion') }}
          </button>
        </h2>
        <div id="collapse7" class="accordion-collapse collapse" data-bs-parent="#generalAccordian">
          <div class="accordion-body">
            <flow-rate-conversion></flow-rate-conversion>
          </div>
        </div>
      </div>

      <!-- Time Conversion -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
            {{ t('headings.TimeConversion') }}
          </button>
        </h2>
        <div id="collapse8" class="accordion-collapse collapse" data-bs-parent="#generalAccordian">
          <div class="accordion-body">
            <time-conversion></time-conversion>
          </div>
        </div>
      </div>

      <!-- Date Calculator -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse9" aria-expanded="false" aria-controls="collapse9">
            {{ t('headings.DateCalculator') }}
          </button>
        </h2>
        <div id="collapse9" class="accordion-collapse collapse" data-bs-parent="#generalAccordian">
          <div class="accordion-body">
            <date-calculator></date-calculator>
          </div>
        </div>
      </div>

      <!-- EC/TDS Conversion -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse10" aria-expanded="false" aria-controls="collapse10">
            {{ t('headings.ECTDSConversion') }}
          </button>
        </h2>
        <div id="collapse10" class="accordion-collapse collapse" data-bs-parent="#generalAccordian">
          <div class="accordion-body">
            <ec-tds-conversion></ec-tds-conversion>
          </div>
        </div>
      </div>

      <!-- Trimming Time Prediction Calculator -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse11" aria-expanded="false" aria-controls="collapse11">
            {{ t('headings.TrimmingTimePredictionCalculator') }}
          </button>
        </h2>
        <div id="collapse11" class="accordion-collapse collapse" data-bs-parent="#generalAccordian">
          <div class="accordion-body">
            <linear-process-calculator></linear-process-calculator>
          </div>
        </div>
      </div>

      <!-- Percentage Calculator -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse12" aria-expanded="false" aria-controls="collapse12">
            {{ t('headings.PercentageCalculator') }}
          </button>
        </h2>
        <div id="collapse12" class="accordion-collapse collapse" data-bs-parent="#generalAccordian">
          <div class="accordion-body">
            <percentage-calculator></percentage-calculator>
          </div>
        </div>
      </div>

      <!-- Cylinder (Ducting) Volume -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse13" aria-expanded="false" aria-controls="collapse13">
            {{ t('headings.CylinderDuctingVolume') }}
          </button>
        </h2>
        <div id="collapse13" class="accordion-collapse collapse" data-bs-parent="#generalAccordian">
          <div class="accordion-body">
            <cylinder-calculator></cylinder-calculator>
          </div>
        </div>
      </div>


      </div>

      </div>


      <div class="mb-4">
      <h2>{{ t('headings.CannabisLightingPowerWaterCalculators') }}</h2>

      <div class="accordion" id="generalLighting">
        <!-- Light Wattage/Lumens -->
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse21" aria-expanded="false" aria-controls="collapse21">
              {{ t('headings.LightWattageLumens') }}
            </button>
          </h2>
          <div id="collapse21" class="accordion-collapse collapse" data-bs-parent="#generalLighting">
            <div class="accordion-body">
              <lighting-calculator></lighting-calculator>
            </div>
          </div>
        </div>

        <!-- Delivered Lumens -->
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse22" aria-expanded="false" aria-controls="collapse22">
              {{ t('headings.DeliveredLumens') }}
            </button>
          </h2>
          <div id="collapse22" class="accordion-collapse collapse" data-bs-parent="#generalLighting">
            <div class="accordion-body">
              <delivered-lighting-calculator></delivered-lighting-calculator>
            </div>
          </div>
        </div>

        <!-- BTUs Generated/Heat Offset Calculator -->
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse23" aria-expanded="false" aria-controls="collapse23">
              {{ t('headings.BTUsGeneratedHeatOffsetCalculator') }}
            </button>
          </h2>
          <div id="collapse23" class="accordion-collapse collapse" data-bs-parent="#generalLighting">
            <div class="accordion-body">
              <BTUCalculator></BTUCalculator>
            </div>
          </div>
        </div>

        <!-- CO₂ Flow Rate -->
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse24" aria-expanded="false" aria-controls="collapse24">
              {{ t('headings.CO2FlowRate') }}
            </button>
          </h2>
          <div id="collapse24" class="accordion-collapse collapse" data-bs-parent="#generalLighting">
            <div class="accordion-body">
              <CO2Calculator></CO2Calculator>
            </div>
          </div>
        </div>

        <!-- Exhaust CFM Calculator -->
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse25" aria-expanded="false" aria-controls="collapse25">
              {{ t('headings.ExhaustCFMCalculator') }}
            </button>
          </h2>
          <div id="collapse25" class="accordion-collapse collapse" data-bs-parent="#generalLighting">
            <div class="accordion-body">
              <ExhaustCalculator></ExhaustCalculator>
            </div>
          </div>
        </div>

        <!-- Light kWh & Cost -->
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse26" aria-expanded="false" aria-controls="collapse26">
              {{ t('headings.LightKWhCost') }}
            </button>
          </h2>
          <div id="collapse26" class="accordion-collapse collapse" data-bs-parent="#generalLighting">
            <div class="accordion-body">
              <amperage-calculator></amperage-calculator>
            </div>
          </div>
        </div>

        <!-- Water Usage/Drip Tip Flow & Cost -->
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse27" aria-expanded="false" aria-controls="collapse27">
              {{ t('headings.WaterUsageDripTipFlowCost') }}
            </button>
          </h2>
          <div id="collapse27" class="accordion-collapse collapse" data-bs-parent="#generalLighting">
            <div class="accordion-body">
              <water-calculator></water-calculator>
            </div>
          </div>
        </div>

        <!-- Time Lapse Image Size -->
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse28" aria-expanded="false" aria-controls="collapse28">
              {{ t('headings.TimeLapseImageSize') }}
            </button>
          </h2>
          <div id="collapse28" class="accordion-collapse collapse" data-bs-parent="#generalLighting">
            <div class="accordion-body">
              <time-lapse-calculator></time-lapse-calculator>
              <time-lapse-size-limit></time-lapse-size-limit>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!---- -->
      
    <div class="mb-4">
    <h2>{{ t('headings.CannabisGrowingFertilizerAgricultureCalculators') }}</h2>

    <div class="accordion" id="generalGrowing">
      <!-- Dew Point -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse31" aria-expanded="false" aria-controls="collapse31">
            {{ t('headings.DewPoint') }}
          </button>
        </h2>
        <div id="collapse31" class="accordion-collapse collapse" data-bs-parent="#generalGrowing">
          <div class="accordion-body">
            <dew-point></dew-point>
          </div>
        </div>
      </div>

      <!-- Vapor Pressure Deficit Calculator (VPD) -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse32" aria-expanded="false" aria-controls="collapse32">
            {{ t('headings.VaporPressureDeficitCalculator') }}
          </button>
        </h2>
        <div id="collapse32" class="accordion-collapse collapse" data-bs-parent="#generalGrowing">
          <div class="accordion-body">
            <vapor-pressure-deficit></vapor-pressure-deficit>
          </div>
        </div>
      </div>

      <!-- Projected Growth Timeline/Calendar -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse33" aria-expanded="false" aria-controls="collapse33">
            {{ t('headings.ProjectedGrowthTimelineCalendar') }}
          </button>
        </h2>
        <div id="collapse33" class="accordion-collapse collapse" data-bs-parent="#generalGrowing">
          <div class="accordion-body">
            <growth-timeline></growth-timeline>
          </div>
        </div>
      </div>

      <!-- Plant Layout -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse34" aria-expanded="false" aria-controls="collapse34">
            {{ t('headings.PlantLayout') }}
          </button>
        </h2>
        <div id="collapse34" class="accordion-collapse collapse" data-bs-parent="#generalGrowing">
          <div class="accordion-body">
            <plant-count></plant-count>
          </div>
        </div>
      </div>

      <!-- Soil Amount to Total -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse35" aria-expanded="false" aria-controls="collapse35">
            {{ t('headings.SoilAmountToTotal') }}
          </button>
        </h2>
        <div id="collapse35" class="accordion-collapse collapse" data-bs-parent="#generalGrowing">
          <div class="accordion-body">
            <soil-calculator></soil-calculator>
          </div>
        </div>
      </div>

      <!-- Soil Ratio to Total -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse36" aria-expanded="false" aria-controls="collapse36">
            {{ t('headings.SoilRatioToTotal') }}
          </button>
        </h2>
        <div id="collapse36" class="accordion-collapse collapse" data-bs-parent="#generalGrowing">
          <div class="accordion-body">
            <soil-ratio-scaling></soil-ratio-scaling>
          </div>
        </div>
      </div>

      <!-- pH/Water Adjustment -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse37" aria-expanded="false" aria-controls="collapse37">
            {{ t('headings.PHWaterAdjustment') }}
          </button>
        </h2>
        <div id="collapse37" class="accordion-collapse collapse" data-bs-parent="#generalGrowing">
          <div class="accordion-body">
            <pHConverter></pHConverter>
          </div>
        </div>
      </div>

      <!-- NPK to PPM TDS -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse38" aria-expanded="false" aria-controls="collapse38">
            {{ t('headings.NPKToPPMTDS') }}
          </button>
        </h2>
        <div id="collapse38" class="accordion-collapse collapse" data-bs-parent="#generalGrowing">
          <div class="accordion-body">
            <NpkToTDS></NpkToTDS>
          </div>
        </div>
      </div>

      <!-- PPM TDS to NPM -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse39" aria-expanded="false" aria-controls="collapse39">
            {{ t('headings.PPMTDSToNPM') }}
          </button>
        </h2>
        <div id="collapse39" class="accordion-collapse collapse" data-bs-parent="#generalGrowing">
          <div class="accordion-body">
            <TdsToNpk></TdsToNpk>
          </div>
        </div>
      </div>

      <!-- Dilution to TDS Target -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse40" aria-expanded="false" aria-controls="collapse40">
            {{ t('headings.DilutionToTDSTarget') }}
          </button>
        </h2>
        <div id="collapse40" class="accordion-collapse collapse" data-bs-parent="#generalGrowing">
          <div class="accordion-body">
            <TDSDilution></TDSDilution>
          </div>
        </div>
      </div>

      <!-- General Crop Yield -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse41" aria-expanded="false" aria-controls="collapse41">
            {{ t('headings.GeneralCropYield') }}
          </button>
        </h2>
        <div id="collapse41" class="accordion-collapse collapse" data-bs-parent="#generalGrowing">
          <div class="accordion-body">
            <yield-calculator></yield-calculator>
          </div>
        </div>
      </div>

      <!-- Dry/Wet Yield -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse42" aria-expanded="false" aria-controls="collapse42">
            {{ t('headings.DryWetYield') }}
          </button>
        </h2>
        <div id="collapse42" class="accordion-collapse collapse" data-bs-parent="#generalGrowing">
          <div class="accordion-body">
            <yield-dry-wet-calculator></yield-dry-wet-calculator>
          </div>
        </div>
      </div>
    </div>
  </div>


    <!---- -->
        

    <div class="mb-4">
    <h2>{{ t('headings.EdibleCalculatorsConcentratesBlending') }}</h2>

    <div class="accordion" id="generalEdiables">
      <!-- Edible Potency -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse51" aria-expanded="false" aria-controls="collapse51">
            {{ t('headings.EdiblePotency') }}
          </button>
        </h2>
        <div id="collapse51" class="accordion-collapse collapse" data-bs-parent="#generalEdiables">
          <div class="accordion-body">
            <VariableServingPotencyVolume></VariableServingPotencyVolume>
            <hr/>
            <VariableServingPotencyWeight></VariableServingPotencyWeight>
            <hr/>
            <VariableServingPotencyVolumeButte></VariableServingPotencyVolumeButte>
          </div>
        </div>
      </div>

      <!-- Oil/Butter Potency -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse52" aria-expanded="false" aria-controls="collapse52">
            {{ t('headings.OilButterPotency') }}
          </button>
        </h2>
        <div id="collapse52" class="accordion-collapse collapse" data-bs-parent="#generalEdiables">
          <div class="accordion-body">
            <EdiblePotency></EdiblePotency>
            <hr/>
            <EdibleProduct></EdibleProduct>
            <hr/>
            <EdibleServings></EdibleServings>
            <hr/>
            <OilButterPotency></OilButterPotency>
            <hr/>
            <PartialOilButter></PartialOilButter>
          </div>
        </div>
      </div>

      <!-- THC/Potency Conversions -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse53" aria-expanded="false" aria-controls="collapse53">
            {{ t('headings.THCPotencyConversions') }}
          </button>
        </h2>
        <div id="collapse53" class="accordion-collapse collapse" data-bs-parent="#generalEdiables">
          <div class="accordion-body">
            <ThcPotency></ThcPotency>
          </div>
        </div>
      </div>

      <!-- Salads & Blending -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse54" aria-expanded="false" aria-controls="collapse54">
            {{ t('headings.SaladsBlending') }}
          </button>
        </h2>
        <div id="collapse54" class="accordion-collapse collapse" data-bs-parent="#generalEdiables">
          <div class="accordion-body">
            <Salad></Salad>
            <hr/>
            <SaladGenerator></SaladGenerator>
          </div>
        </div>
      </div>

      <!-- Decarboxylation Loss -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse55" aria-expanded="false" aria-controls="collapse55">
            {{ t('headings.DecarboxylationLoss') }}
          </button>
        </h2>
        <div id="collapse55" class="accordion-collapse collapse" data-bs-parent="#generalEdiables">
          <div class="accordion-body">
            <DecarbLoss></DecarbLoss>
          </div>
        </div>
      </div>

      <!-- Decarboxylation Curve Prediction -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse56" aria-expanded="false" aria-controls="collapse56">
            {{ t('headings.DecarboxylationCurvePrediction') }}
          </button>
        </h2>
        <div id="collapse56" class="accordion-collapse collapse" data-bs-parent="#generalEdiables">
          <div class="accordion-body">
            <decarb-curve></decarb-curve>
          </div>
        </div>
      </div>

      <!-- Extraction Efficiency -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse57" aria-expanded="false" aria-controls="collapse57">
            {{ t('headings.ExtractionEfficiency') }}
          </button>
        </h2>
        <div id="collapse57" class="accordion-collapse collapse" data-bs-parent="#generalEdiables">
          <div class="accordion-body">
            <extraction-efficiency></extraction-efficiency>
          </div>
        </div>
      </div>

      <!-- Solvent Evaporation Time Estimate -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse58" aria-expanded="false" aria-controls="collapse58">
            {{ t('headings.SolventEvaporationTimeEstimate') }}
          </button>
        </h2>
        <div id="collapse58" class="accordion-collapse collapse" data-bs-parent="#generalEdiables">
          <div class="accordion-body">
            <evap-prediction></evap-prediction>
          </div>
        </div>
      </div>

      <!-- Concentrate to Capsule THC Breakdown -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse59" aria-expanded="false" aria-controls="collapse59">
            {{ t('headings.ConcentrateToCapsuleTHCBreakdown') }}
          </button>
        </h2>
        <div id="collapse59" class="accordion-collapse collapse" data-bs-parent="#generalEdiables">
          <div class="accordion-body">
            <capsule-calculator></capsule-calculator>
          </div>
        </div>
      </div>

      <!-- Max Percent Constituent (Terpene Addition) -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse60" aria-expanded="false" aria-controls="collapse60">
            {{ t('headings.MaxPercentConstituentTerpeneAddition') }}
          </button>
        </h2>
        <div id="collapse60" class="accordion-collapse collapse" data-bs-parent="#generalEdiables">
          <div class="accordion-body">
            <percent-constituent></percent-constituent>
          </div>
        </div>
      </div>
    </div>
  </div>

        

    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue';

import WeightConversion from './components/general/WeightConversion.vue';

import DistanceConversion from './components/general/DistanceConversion.vue';

import TemperatureConversion from './components/general/TemperatureConversion.vue';

import SpeedConversion from './components/general/SpeedConversion.vue';

import AreaConversion from './components/general/AreaConversion.vue';

import VolumeConversion from './components/general/VolumeConversion.vue';

import FlowRateConversion from './components/general/FlowRateConversion.vue'; 

import TimeConversion from './components/general/TimeConversion.vue';

import EcTdsConversion from './components/general/EcTdsConversion.vue';

import CylinderCalculator from './components/general/CylinderCalculator.vue';

import DateCalculator from './components/general/DateCalculator.vue';


import LinearProcessCalculator from './components/general/LinearProcessCalculator.vue';

import PercentageCalculator from './components/general/PercentageCalculator.vue'; 

import LightingCalculator from './components/general/LightingCalculator.vue';

import DeliveredLightingCalculator from './components/equipment_power/DeliveredLightingCalculator.vue';

import BTUCalculator from './components/equipment_power/BTUCalculator.vue';

import CO2Calculator from './components/equipment_power/CO2Calculator.vue';

import ExhaustCalculator from './components/equipment_power/ExhaustCalculator.vue'; // Adjust the path as needed

import AmperageCalculator from './components/equipment_power/AmperageCalculator.vue';

import WaterCalculator from './components/equipment_power/WaterCalculator.vue';

import TimeLapseCalculator from './components/equipment_power/TimeLapseCalculator.vue'; 

import TimeLapseSizeLimit from './components/equipment_power/TimeLapseSizeLimit.vue';

import DewPoint from './components/plants_consumables/DewPoint.vue';

import VaporPressureDeficit from './components/plants_consumables/VaporPressureDeficit.vue';

import GrowthTimeline from './components/plants_consumables/GrowthTimeline.vue';

import PlantCount from './components/plants_consumables/PlantCount.vue';

import SoilCalculator from './components/plants_consumables/SoilCalculator.vue';

import SoilRatioScaling from './components/plants_consumables/SoilRatioScaling.vue';

import pHConverter from './components/plants_consumables/pHConverter.vue';

import NpkToTDS from './components/plants_consumables/NpkToTDS.vue';

import TdsToNpk from './components/plants_consumables/TdsToNpk.vue';

import TDSDilution from './components/plants_consumables/TDSDilution.vue';

import YieldCalculator from './components/plants_consumables/YieldCalculator.vue';

import YieldDryWetCalculator from './components/plants_consumables/YieldDryWetCalculator.vue';

import VariableServingPotencyVolume from './components/edibles_concentrates/VariableServingPotencyVolume.vue';

import VariableServingPotencyWeight from './components/edibles_concentrates/VariableServingPotencyWeight.vue';

import VariableServingPotencyVolumeButte from './components/edibles_concentrates/VariableServingPotencyVolumeButte.vue';

import EdiblePotency from './components/edibles_concentrates/EdiblePotency.vue';

import EdibleProduct from './components/edibles_concentrates/EdibleProduct.vue';

import EdibleServings from './components/edibles_concentrates/EdibleServings.vue';

import OilButterPotency from './components/edibles_concentrates/OilButterPotency.vue';

import PartialOilButter from './components/edibles_concentrates/PartialOilButter.vue';

import ThcPotency from './components/edibles_concentrates/ThcPotency.vue';

import Salad from './components/edibles_concentrates/Salad.vue';

import SaladGenerator from './components/edibles_concentrates/SaladGenerator.vue';

import DecarbLoss from './components/edibles_concentrates/DecarbLoss.vue';

import DecarbCurve from './components/edibles_concentrates/DecarbCurve.vue';

import ExtractionEfficiency from './components/edibles_concentrates/ExtractionEfficiency.vue';

import EvapPrediction from './components/edibles_concentrates/EvapPrediction.vue';

import CapsuleCalculator from './components/edibles_concentrates/CapsuleCalculator.vue';

import PercentConstituent from './components/edibles_concentrates/PercentConstituent.vue';

import { useI18n } from 'vue-i18n';

export default {
  name: 'App',
  components: {
    WeightConversion,
    DistanceConversion,
    TemperatureConversion,
    SpeedConversion,
    AreaConversion,
    VolumeConversion,
    FlowRateConversion,
    TimeConversion,
    EcTdsConversion,
    CylinderCalculator,
    DateCalculator,
    LinearProcessCalculator,
    PercentageCalculator,
    LightingCalculator,
    DeliveredLightingCalculator,
    BTUCalculator,
    CO2Calculator,
    ExhaustCalculator,
    AmperageCalculator,
    WaterCalculator,
    TimeLapseCalculator,
    TimeLapseSizeLimit,
    DewPoint,
    VaporPressureDeficit,
    GrowthTimeline,
    PlantCount,
    SoilCalculator,
    SoilRatioScaling,
    pHConverter,
    NpkToTDS,
    TdsToNpk,
    TDSDilution,
    YieldCalculator,
    YieldDryWetCalculator,



    VariableServingPotencyVolume,
    VariableServingPotencyWeight,
    VariableServingPotencyVolumeButte,
    EdiblePotency,
    EdibleProduct,
    EdibleServings,
    OilButterPotency,
    PartialOilButter,
    ThcPotency,
    Salad,
    SaladGenerator,
    DecarbLoss,
    DecarbCurve,
    ExtractionEfficiency,
    EvapPrediction,
    CapsuleCalculator,
    PercentConstituent

  },

  setup() {

    const { t, locale } = useI18n();

    // Create a reactive object with a function
    const translations = reactive({
      t: (key) => t(key)
    })


    const hideSplitter = ref(false);

    // Function to change locale
    const changeLocale = (newLocale) => {
        locale.value = newLocale;
    }


    return {
      hideSplitter,
      t: translations.t,
      // WeightConversionTitle,
      // DistanceConversionTitle,
      changeLocale
    };
  }
};
</script>

<style>
/* Add some basic styling */

@media (min-width: 768px){
  .text-label {
    min-width: 180px;
  }
}



</style>
